import { ABSENCE_REPORT_BALANCE_ITEMS } from '../../../constants/absence';
import { PARAMS } from '../../../constants/pages';

export const formatAbsenceReportDays = (value, translations) => {
  if (value === null || value === undefined) return '-';

  const dayLabel = Math.abs(value) !== 1 ? translations.days : translations.day;

  return `${value} ${dayLabel}`;
};

export const prepareAbsenceReportCompanyStatsParams = ({
  selectedAbsenceType,
}) => ({
  [PARAMS.ABSENCE]: selectedAbsenceType?.id,
});

export const prepareAbsenceReportUserStatsParams = ({
  selectedAbsenceType,
  search,
  page,
}) => ({
  [PARAMS.ABSENCE]: selectedAbsenceType?.id,
  ...(search ? { [PARAMS.SEARCH]: search } : {}),
  ...(page ? { [PARAMS.PAGE]: page } : {}),
});

export const prepareAbsenceReportUserStatsRows = (results, translations) =>
  (results ?? []).map(result => {
    const balanceValues = ABSENCE_REPORT_BALANCE_ITEMS.reduce(
      (acc, { value }) => ({
        ...acc,
        [value]: formatAbsenceReportDays(result[value], translations),
      }),
      {}
    );

    return {
      id: result.id,
      user: result,
      ...balanceValues,
    };
  });

export const getTableHeaders = labels => [
  {
    id: 1,
    title: labels.name,
    rowKey: 'name',
    minWidth: 180,
    maxWidth: '1.5fr',
    hasConditionalTooltip: true,
    isHighlighted: true,
  },
  ...ABSENCE_REPORT_BALANCE_ITEMS.map(({ key, value }, index) => ({
    id: index + 2,
    title: labels[key],
    rowKey: value,
    maxWidth: '1fr',
    hasConditionalTooltip: true,
  })),
];

export const prepareTableRows = (rows, renderUser) =>
  rows.map(row => {
    const { id, user, ...balanceValues } = row;

    return {
      id,
      name: renderUser(user),
      ...balanceValues,
    };
  });

export const prepareDetailsUrl = userId => `/people/${userId}/absences`;
